import { motion } from "framer-motion";

// Masked line-by-line reveal for headings
export const RevealLines = ({ lines, className = "", delay = 0, testId }) => {
  return (
    <span className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span className="reveal-line" key={i}>
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1,
              ease: [0.16, 1, 0.3, 1],
              delay: delay + i * 0.12,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Scroll-triggered fade up
export const FadeUp = ({ children, className = "", delay = 0, y = 40, testId }) => (
  <motion.div
    className={className}
    data-testid={testId}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);

// Masked reveal for a single scroll-triggered line block
export const RevealOnScroll = ({ children, className = "", delay = 0 }) => (
  <span className="reveal-line">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.span>
  </span>
);
